import styled from "styled-components";

export const OptInJackpotBetDialogDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    background:${props => props.theme.colors.backgroundMiddleDark};
    @media ${({theme}) => `${theme.mediaQuery.lAndAbove}`} {
        max-height: 630px;
        max-width: 496px;
    }
    max-height: calc(100dvh - 1rem);
`;
